export default (currency) => {
  const currencies = {
    EUR: () => "€",
    GBP: () => "£",
    USD: () => "$",
    SGD: () => "S$",
    CHF: () => "Fr.",
    CAD: () => "C$",
    default: () => currency,
  };

  return (currencies[currency] || currencies.default)();
};

export const currencies = ["EUR", "GBP", "USD", "SGD", "CHF"];
